import { SyncEventType } from '../../enums/syncEventType';
import { Sprint } from '../../sprint';
import { PersistenceEvent } from './persistenceEvent';

export class EventSprintUpdated implements PersistenceEvent {

  public readonly type = SyncEventType.SPRINT_UPDATED;
  public sprint: Sprint;

  constructor(sprint: Sprint) {
    this.sprint = sprint;
  }

  getPayload(): object {
    const payload = {
      'sprint': this.sprint
    };
    return payload;
  }

  static fromPayload(payload: any): EventSprintUpdated {
    return new EventSprintUpdated(
      payload['sprint']
    );
  }

}

